<template>
  <section>
    <ul>
      <h4>Subcribe to our Newsletter:</h4>
      <p>
        Get 10% off on your first order by Subcribing to our newsletter. You'll
        receive emails on updates, limited offers and new release!
      </p>
      <p>Email*</p>
      <input type="text" />
      <button>Submit</button>
    </ul>
    <ul>
      <h4>Shop</h4>
      <li class="first">Furniture</li>
      <li>Lighting</li>
      <li>Rugs</li>
      <li>New</li>
      <li>Sale</li>
    </ul>
    <ul>
      <h4>Customer Service</h4>
      <li class="first">Shipping & Returns</li>
      <li>Store Policy</li>
      <li>Payment Methods</li>
      <li>FAQ</li>
    </ul>
    <ul>
      <h4>About Home Décor</h4>
      <li class="first">Our Story</li>
      <li>Brand & Designers</li>
      <li>Stores</li>
      <li>Contact</li>
    </ul>
  </section>
  <div class="social">
    <div class="logo">
      <img alt="" src="@/assets/Logo.png" loading="eager" decoding="async" />
      <router-link to="/">
        <h2>Home Décor</h2>
      </router-link>
    </div>
    <div class="icon">
      <ul class="wrapper">
        <li class="icon facebook">
          <a href="https://www.facebook.com/" target="_blank">
            <font-awesome-icon :icon="['fab', 'facebook-f']" />
          </a>
        </li>
        <li class="icon twitter">
          <a href="https://twitter.com/" target="_black">
            <font-awesome-icon :icon="['fab', 'twitter']" />
          </a>
        </li>
        <li class="icon instagram">
          <a href="https://www.instagram.com/" target="_blank">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  margin: 0 15%;
  margin-bottom: 30px;

  ul {
    list-style: none;
    padding-left: 0;
    padding-top: 10px;

    &:nth-child(2),
    &:nth-child(3),
    &:last-child {
      text-align: justify;
      margin: 0 auto;
    }

    p,
    .first {
      margin-top: 10px;
    }

    input {
      width: 100%;
      height: 20%;
      border: 1px solid rgba($color: #000, $alpha: 0.3);
    }

    button {
      color: #000;
      border: 1px solid rgba($color: #000, $alpha: 0.3);
      padding: 10px 20px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        transform: scale(0.95);
      }
    }
  }
}

.social {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  margin: 0 15%;

  .logo {
    display: flex;
    align-items: center;

    img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }

  a {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 21px;
    color: #000000;
    text-decoration: none;
    gap: 10px;
  }

  .icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    ul {
      display: flex;
      list-style: none;
      padding-left: 0;

      li {
        margin-right: 10px;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          transform: scale(0.95);
        }
      }
    }
  }
}

@media screen and (max-width: 999px) {
  section {
    grid-template-columns: repeat(2, 1fr);
    margin: 0 8% !important;
    gap: 25px;
  }

  ul:nth-child(2),
  ul:nth-child(3),
  ul:last-child {
    margin: 0 !important;
  }

  input {
    width: 100%;
  }

  .social {
    .logo {
      img {
        width: 40px;
        height: 40px;
      }

      h2 {
        font-size: 15px;
      }
    }
  }
}
</style>
